import React from "react";
import Top from "./top/Top";
import Bottom from "./bottom/Bottom";
import first1 from "../../images/syllabusimage/first1.jpeg";
import second from "../../images/syllabusimage/second.jpeg";
import third from "../../images/syllabusimage/third.jpeg";
import fourth from "../../images/syllabusimage/fourth.jpeg";
import fifth from "../../images/syllabusimage/fifth.jpeg";
import sixth from "../../images/syllabusimage/sixth.jpeg";
import seventh from "../../images/syllabusimage/seventh.jpeg";
import eightth from "../../images/syllabusimage/eightth.jpeg";
// import { Link } from "react-router-dom";
// import syllabus1 from "../../../src/pdf/syllabus1.pdf"
const Syllabus = () => {
  return (
    <>
      <div className="mt-9">
        <div>
          <h1 className="text-center text-3xl font-bold lg:text-5xl">
            Syllabus{" "}
            <a className="underline decoration-orange-700">2023-2024</a>
          </h1>
        </div>

        <div className="lg:mt-11">
          <div className="lg:flex lg:justify-evenly">
            <Top
              title="P.G."
              image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS9dv5uhB9SduCVh51MA8MH4H_Ria0eW0hiCkS7cce8P55ulTLtrWH4_qB5hde5mvoJijU&usqp=CAU"
              syllabus=""
            />
            <Top
              title="Nursery"
              image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS9dv5uhB9SduCVh51MA8MH4H_Ria0eW0hiCkS7cce8P55ulTLtrWH4_qB5hde5mvoJijU&usqp=CAU"
              syllabus=""
            />
            <Top
              title="L.K.G"
              image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS9dv5uhB9SduCVh51MA8MH4H_Ria0eW0hiCkS7cce8P55ulTLtrWH4_qB5hde5mvoJijU&usqp=CAU"
              syllabus=""
            />
          </div>
          <div className="lg:flex lg:justify-evenly">
            <Top
              title="U.K.G"
              image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS9dv5uhB9SduCVh51MA8MH4H_Ria0eW0hiCkS7cce8P55ulTLtrWH4_qB5hde5mvoJijU&usqp=CAU"
              syllabus=""
            />
            <Bottom
              title1="I"
              image1={first1}
              syllabus="https://in.docworkspace.com/d/sIEKPpsS-Aaix56cG"
            />
            <Bottom
              title1="II"
              image1={second}
              syllabus="https://in.docworkspace.com/d/sII-PpsS-AY-x56cG"
            />
          </div>

          <div className="lg:flex lg:justify-evenly">
            <Bottom
              title1="III"
              image1={third}
              syllabus="https://in.docworkspace.com/d/sICqPpsS-AZCw56cG"
            />
            <Bottom
              title1="IV"
              image1={fourth}
              syllabus="https://in.docworkspace.com/d/sIFyPpsS-AeWv56cG"
            />
            <Bottom
              title1="V"
              image1={fifth}
              syllabus="https://in.docworkspace.com/d/sIKyPpsS-Acyv56cG"
            />
          </div>
          <div className="lg:flex lg:justify-evenly">
            <Bottom
              title1="VI"
              image1={sixth}
              syllabus="https://in.docworkspace.com/d/sIOSPpsS-AbWv56cG"
            />
            <Bottom
              title1="VII"
              image1={seventh}
              syllabus="https://in.docworkspace.com/d/sIASPpsS-AduJ7acG"
            />
            <Bottom
              title1="VIII"
              image1={eightth}
              syllabus="https://in.docworkspace.com/d/sIBePpsS-Acex56cG"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Syllabus;
